import type { ApiError } from '../types';
import type { Tag } from './tags';

type Response = Record<string, unknown>;

export function invalidator<R extends Response | void, A extends Response | void>(
  tag: Tag,
  resultKey?: string,
  argsKey?: string
) {
  return function (result: R | void, error: ApiError | undefined, args: A) {
    if (error) {
      return [];
    }

    const id = resultKey && result ? result[resultKey] : argsKey && args ? args[argsKey] : undefined;

    if (!id || typeof id !== 'string') {
      return [tag];
    }

    return [{ type: tag, id }];
  };
}

export function invalidateMultiple<R extends Response | void, A extends Response | void>(
  tags: Array<Tag>,
  resultKey?: string,
  argsKey?: string
) {
  return function (result: R | void, error: ApiError | undefined, args: A) {
    if (error) {
      return [];
    }

    const id = resultKey && result ? result[resultKey] : argsKey && args ? args[argsKey] : undefined;

    if (!id || typeof id !== 'string') {
      return tags;
    }

    return tags.map((tag) => ({ type: tag, id }));
  };
}
